import { useCallback, useMemo } from 'react';
import useHomeContext from '@/hooks/useHomeContext';
import { scheduledPaymentModal } from '@/utils/translations';

/**
 * Looks up a business member's display name with zero extra network calls: Home.tsx already
 * fetches the full team member list once on mount (GET /businesses/{id}/members) and holds it
 * in HomeContext, so this just indexes the array already in memory instead of hitting an API
 * per customer id.
 */
export const useTeamMemberNameLookup = () => {
  const { teamMembers } = useHomeContext()!;

  const namesById = useMemo(
    () => new Map(teamMembers.map((member) => [member.id, member.name])),
    [teamMembers]
  );

  return useCallback(
    (customerId?: string | null): string =>
      (customerId && namesById.get(customerId)) || scheduledPaymentModal.unknownName,
    [namesById]
  );
};
